import React__default from 'react';

var ArticleSummary = function ArticleSummary(props) {
  var summary = props.summary,
    isVertical = props.isVertical;
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-summary",
    className: isVertical ? 'mb-4 flex flex-col justify-center self-stretch font-serif text-[18px]/[32px] tracking-[0.01px] md:mb-0 lg:text-p-24' : 'flex flex-col justify-center self-stretch pt-4 font-serif text-[18px]/[32px] tracking-[0.01px] lg:text-p-24'
  }, summary);
};

export { ArticleSummary };
//# sourceMappingURL=article-summary.esm.js.map
